import { render, staticRenderFns } from "./EditPosServer.vue?vue&type=template&id=d6b5eb20"
import script from "./EditPosServer.vue?vue&type=script&lang=js"
export * from "./EditPosServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports